import angular from "angular";

angular
    .module('invitesControl.invite', [])
    .service('Invite', ['$http', function ($http) {

        function uri(id, path) {
            let link = '/control-panel/invites';
            if (id) {
                link += '/' + id;
            }
            if (path) {
                link += '/' + path;
            }
            return link;
        }

        this.getList = function (params) {
            return $http.get(uri(null, 'get-list'), {params: params});
        };

        this.create = function (params) {
            return $http.post(uri(), params)
        };

        this.retrySend = function (id) {
            return $http.post(uri(id, 'retry-send'));
        };

        this.cancel = function (id) {
            return $http.post(uri(id, 'cancel'));
        };

        this.destroy = function (id) {
            return $http.post(uri(id), {_method: 'DELETE'})
        };

    }]);

export default 'invitesControl.invite';


// WEBPACK FOOTER //
// ./resources/assets/modules/invites-control/invite.js